

// src/components/Footer.jsx
import React from "react";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row">
          {/* Contact Section */}
          <div className="col-lg-4">
            <div className="widget">
              <h3>Contact</h3>
              <address><u>CORBILTEK PVT LTD</u></address>
              <address>21/152, Panadans, Kalamassery, Kochi University</address>
              <address>Ernakulam, Kerala, 682022</address>
              <ul className="list-unstyled links">
                <li><a href="tel:+919496152037">+91-9496-152-037</a></li>
                <li><a href="tel:+919847152037">+91-9847-152-037</a></li>
                <li><a href="mailto:corbiltekpvtltd@gmail.com">corbiltekpvtltd@gmail.com</a></li>
              </ul>

            </div>
          </div>

          {/* Sources Section */}
          <div className="col-lg-4">
            {/* <div className="widget">
              <h3>Sources</h3>
              <div className="d-flex justify-content-between">
                <ul className="list-unstyled links">
                  <li><a href="">About us</a></li>
                  <li><a href="">Services</a></li>
                  <li><a href="">Vision</a></li>
                  <li><a href="">Homin</a></li>
                  <li><a href="">Contact</a></li>
                </ul>
                <ul className="list-unstyled links">
                  <li><a href="">Partners</a></li>
                  <li><a href="">Business</a></li>
                  <li><a href="">Careers</a></li>
                  <li><a href="">Blog</a></li>
                  <li><a href="">FAQ</a></li>
                  <li><a href="">Creative</a></li>
                </ul>
              </div>
            </div> */}
          </div>

          {/* Links Section */}
          <div className="col-lg-4">
            <div className="widget">
              <h3>Links</h3>
              <ul className="list-unstyled links">
                <li><a href="#mainSlider">Home</a></li>
                <li><a href="#aboutInfo">About us</a></li>
                <li><a href="#services_Info">Our Services</a></li>
                <li><a href="#contact_Info">Contact us</a></li>
                <li><a href="#newLaunch">New Launches</a></li>
              </ul>

              <ul className="list-unstyled social d-flex gap-2">
                <li><a href=""><span className="icon-instagram"></span></a></li>
                <li><a href=""><span className="icon-twitter"></span></a></li>
                <li><a href=""><span className="icon-facebook"></span></a></li>
                <li><a href=""><span className="icon-linkedin"></span></a></li>
                <li><a href=""><span className="icon-pinterest"></span></a></li>
                <li><a href=""><span className="icon-dribbble"></span></a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="row mt-5">
          <div className="col-12 text-center">
            <p>
              Copyright &copy; {new Date().getFullYear()}.
              All Rights Reserved. &mdash; Designed with love by{" "}
              <a href="https://brandingsparrow.com/">Branding Sparrow</a>
            </p>
            <div>
              Distributed by{" "}
              <a href="https://brandingsparrow.com/" target="_blank" rel="noreferrer">
                Branding Sparrow
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
